import React, { Fragment } from 'react';
import classNames from 'classnames';
import { statusTimestampCheck } from '@gumtree/shared/src/util/date-helpers';

import SellerStatsBlock from './seller-stats-block';

import './seller-stats.scss';
/** will only show information if l1Category is set to 2549, some data is hidden if below a threshold */
const SellerStats = ({
    sellerStats: { postingSince },
    l1Category,
    showRating = false,
    vipSellerInfo
}: Props) => {
    const inForSaleCategory = 2549;
    const className = classNames('seller-stats-component', {
        'seller-stats-newLayout': inForSaleCategory,
        'seller-stats-component--inline': !inForSaleCategory,
        'seller-stats-no-rating': inForSaleCategory && !showRating,
    });

    return (
        <Fragment>
            {l1Category === inForSaleCategory && (
                <div className={className} data-testid="seller-stats-component">
                    {postingSince && !inForSaleCategory ? (
                        <SellerStatsBlock
                            icon="all_categories"
                            message="Posting for"
                            value={postingSince}
                        />
                    ) : (
                        <>
                            <SellerStatsBlock
                                message="Posting for"
                                value={postingSince}
                                strong={false}
                                className="newLayout"
                            />
                            {vipSellerInfo.lastActiveStatus && (
                                <div className="seller-stats-active">
                                    <span>|</span>
                                    <div>{statusTimestampCheck(vipSellerInfo.lastActiveStatus)}</div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}
        </Fragment>
    );
};

export interface Props {
    l1Category: number,
    sellerStats: { postingSince: string }
    showRating: boolean,
    vipSellerInfo: {
        lastActiveStatus: string | null
    }
}

export default SellerStats;
